import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';
import Dialogmessage from '../../loading';
class Model extends Component {

  state = {
    model: [],
    load: false,
  }

  componentDidUpdate(props) {
    if (props.data != this.props.data) {
      this.setCategory();
      this.selected();
    }
  }


  setCategory() {
    let context = this;
    var model = [];
    this.props.data.map((y) => {
      if (y.type == 'model') {
        model.push({key: y.name, text: y.name, value: y.name});
      }
    });
    context.setState({
      modelOption: model,
    });
  }

  selected() {
    let context = this;
    var model = [];
    this.props.data.map((y) => {
      if (y.type == 'selectedmodel') {
        model.push(y.name);
      }
    });
    context.setState({
      model: model,
    });
  }

  add(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Adding category!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/addsparemodel.php',
      success: function(data)
      {
          console.log(data);
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  remove(value) {
    let context = this;
    context.setState({
      load: true,
      message: 'Removing category!!!'
    });
    let data1 = {'partno': this.props.partno, 'value': value};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/removesparemodel.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  closedialog() {
    this.setState({
      dialogstatus: false
    })
  }

  check(value) {
    let oldValue = this.state.model;
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      for (var i = 0; i < oldValue.length; i++) {
        if (length == 0) {
          this.remove(oldValue[i]);
          return;
        }
        for (var j = 0; j < length; j++) {
          if (oldValue[i] != value[j]) {
            this.remove(oldValue[i]);
            return;
          }
        }
      }
    }
  }

  Model = (f, { value }) => {
    this.check(value);
    this.setState({ model: value })
  }

  render() {
    let { model } = this.state;
    let { load, message } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
      <Dropdown placeholder='Model' style={{ borderColor: '#5A9CBB' }}
       multiple search selection onChange={this.Model}
       options={this.state.modelOption} fluid value={model} />
       {loading}
      </div>
    );
  }
}

export default Model;
